import { ProviderType } from './ObjectTypes';
import { checkSchema } from './SchemaFormTemplates/checkSchema';

export type RouteKind = 'webhook' | 'push-only' | 'standard';

export function getRouteKind(providerType: ProviderType): RouteKind {
  // Before the pull check: a webhook type's credentials and pull actions serve its other role, not its inbound data.
  if (providerType.value === 'generic_webhooks' || providerType.webhook)
    return 'webhook';
  const hasPullConfig = providerType.actions
    ?.filter((a) => a.type !== 'push')
    .some((a) => checkSchema(a));
  if (hasPullConfig) return 'standard';
  return 'push-only';
}

export function providerHasPushAction(providerType: ProviderType): boolean {
  return providerType.actions?.some((a) => a.type === 'push') ?? false;
}
